import fetch from '../../httpService/fetch';

//查询审批
const flowBaeUrl = '/grt-pageflow-service/flow/process/v1',
    getApprovalInfoUrl = flowBaeUrl;

export function getApprovalInfoReq(params) {
    return fetch.get(getApprovalInfoUrl, params);
}
